import React from 'react';
import { UserIcon, MailIcon, PhoneIcon, MapPinIcon, DollarSignIcon, CalendarIcon, BuildingIcon } from 'lucide-react';
import { CustomerRecord } from './DuplicateCard';
type RecordCardProps = {
  record: CustomerRecord;
  side: 'left' | 'right';
  isSelected?: boolean;
};
export function RecordCard({
  record,
  side,
  isSelected
}: RecordCardProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  return <div className={`bg-white rounded-lg border-2 p-4 transition-all duration-200 ${isSelected ? 'border-blue-500 shadow-md' : 'border-gray-200 shadow-sm'}`} role="article" aria-label={`${side === 'left' ? 'Primary' : 'Secondary'} record for ${record.firstName} ${record.lastName}`} data-id="element-309">
      {/* Header */}
      <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-100" data-id="element-310">
        <div className="flex items-center gap-3" data-id="element-311">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center ${side === 'left' ? 'bg-blue-100 text-blue-600' : 'bg-purple-100 text-purple-600'}`} data-id="element-312">
            <UserIcon className="w-5 h-5" aria-hidden="true" data-id="element-313" />
          </div>
          <div data-id="element-314">
            <h3 className="text-sm font-semibold text-gray-900" data-id="element-315">
              {record.firstName} {record.lastName}
            </h3>
            <p className="text-xs text-gray-500" data-id="element-316">ID: {record.id}</p>
          </div>
        </div>
        <span className={`text-xs font-medium px-2 py-1 rounded-full ${side === 'left' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`} data-id="element-317">
          {side === 'left' ? 'Record A' : 'Record B'}
        </span>
      </div>

      {/* Details */}
      <div className="space-y-3" data-id="element-318">
        <div className="flex items-center gap-3 text-sm" data-id="element-319">
          <MailIcon className="w-4 h-4 text-gray-400 flex-shrink-0" aria-hidden="true" data-id="element-320" />
          <span className="text-gray-700 truncate" data-id="element-321">{record.email}</span>
        </div>

        <div className="flex items-center gap-3 text-sm" data-id="element-322">
          <PhoneIcon className="w-4 h-4 text-gray-400 flex-shrink-0" aria-hidden="true" data-id="element-323" />
          <span className="text-gray-700" data-id="element-324">{record.phone}</span>
        </div>

        <div className="flex items-center gap-3 text-sm" data-id="element-325">
          <MapPinIcon className="w-4 h-4 text-gray-400 flex-shrink-0" aria-hidden="true" data-id="element-326" />
          <span className="text-gray-700 truncate" data-id="element-327">{record.address}</span>
        </div>

        <div className="flex items-center gap-3 text-sm" data-id="element-328">
          <DollarSignIcon className="w-4 h-4 text-gray-400 flex-shrink-0" aria-hidden="true" data-id="element-329" />
          <span className="text-gray-900 font-semibold" data-id="element-330">
            {formatCurrency(record.loanAmount)}
          </span>
        </div>

        <div className="flex items-center gap-3 text-sm" data-id="element-331">
          <CalendarIcon className="w-4 h-4 text-gray-400 flex-shrink-0" aria-hidden="true" data-id="element-332" />
          <span className="text-gray-700" data-id="element-333">
            {formatDate(record.applicationDate)}
          </span>
        </div>

        <div className="flex items-center gap-3 text-sm" data-id="element-334">
          <BuildingIcon className="w-4 h-4 text-gray-400 flex-shrink-0" aria-hidden="true" data-id="element-335" />
          <span className="text-gray-500 text-xs" data-id="element-336">Source: {record.source}</span>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-4 pt-4 border-t border-gray-100 text-xs text-gray-500" data-id="element-337">
        Created: {formatDate(record.createdAt)}
      </div>
    </div>;
}